import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39aa2a49"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "placeholder"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { computed, ref, watch, withDefaults } from 'vue';
import { SssStaffOpt, SssBaseOpt } from '@/utility/SelectStaffSearch';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStaffSearch',
  props: {
    modelValue: null,
    staffOpts: null,
    baseOpts: null,
    disabled: { type: Boolean },
    class: { default: '' },
    placeholder: null
  },
  emits: ["update:modelValue", "input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number): void;
  (e: 'input'): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, staffOpts: SssStaffOpt[], baseOpts: SssBaseOpt[], disabled?: boolean, class: string, placeholder?: string }




const inputText = ref('');
watch(inputText, () => {
  setModel();
});

const model = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
});

watch(
  () => [props.modelValue, props.staffOpts, props.baseOpts],
  () => {
    setInputText();
  }
);
watch(
  () => props.baseOpts,
  () => {
    baseChecks.value = {};
    props.baseOpts.forEach(v => (baseChecks.value[v.bCode] = false));
  }
);

const isPopup = ref(false);
const filteredStaffOpts = computed(() => props.staffOpts.filter(v => v.sName.indexOf(inputText.value) >= 0));
const filteredBCodes = computed(() => Array.from(new Set(filteredStaffOpts.value.map(v => v.bCodes).flat())));
const filteredBaseOpts = computed(() => props.baseOpts.filter(v => filteredBCodes.value.some(x => x === v.bCode)));
const baseChecks = ref<Record<string, boolean>>({});

const refText = ref<HTMLInputElement>();
const refSelect = ref<HTMLInputElement>();

function setInputText() {
  inputText.value = props.staffOpts.find(v => v.sCode === model.value)?.sName ?? '';
}

function setModel() {
  model.value = props.staffOpts.find(v => v.sName === inputText.value)?.sCode ?? 0;
}

function onStaffClick(staffOpt: SssStaffOpt) {
  inputText.value = staffOpt.sName;
  isPopup.value = false;
}

function onBaseClick(baseOpt: SssBaseOpt) {
  baseChecks.value[baseOpt.bCode] = !baseChecks.value[baseOpt.bCode];
}

function init() {
  setInputText();
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select-staff-search", props.class])
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "refText",
      ref: refText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputText).value = $event)),
      disabled: props.disabled,
      placeholder: props.placeholder,
      type: "text",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput, emit('input'))),
      onChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change'))),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (isPopup.value = true))
    }, null, 40, _hoisted_1), [
      [
        _vModelText,
        inputText.value,
        void 0,
        { trim: true }
      ]
    ]),
    (isPopup.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "refSelect",
          ref: refSelect,
          class: "popup"
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBaseOpts), (base) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: base.bCode
              }, [
                _createElementVNode("li", {
                  class: "base",
                  onClick: _withModifiers(($event: any) => (onBaseClick(base)), ["stop","exact"])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ checked: baseChecks.value[base.bCode] })
                  }, _toDisplayString(base.bNTiny), 3)
                ], 8, _hoisted_2),
                (baseChecks.value[base.bCode])
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(filteredStaffOpts).filter(v => v.bCodes.some(x => x === base.bCode)), (staff) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: staff.sCode,
                        class: "staff",
                        onClick: _withModifiers(($event: any) => (onStaffClick(staff)), ["stop","exact"])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(staff.sName), 1)
                      ], 8, _hoisted_3))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(isPopup.value ? 'back-class' : ''),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (isPopup.value = false), ["self"]))
    }, null, 2)
  ], 2))
}
}

})